import { Directive } from '@angular/core';

@Directive({
    selector: '[pItemListDef]',
})
export class ItemListDefDirective {}
